import { defineStyles, defineSlotRecipe } from "@pandacss/dev";
import tableBorderStyles from "./utils/tableBorderStyles";

const cellStyles = defineStyles({
  height: "xl",
  paddingInline: "padding.3",
  "&[data-first]": {
    paddingLeft: "padding.4",
  },
  "&[data-last]": {
    paddingRight: "padding.4",
  },
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
});

export const slots = [
  "wrapper",
  "container",
  "root",
  "body",
  "caption",
  "head",
  "header",
  "headerContent",
  "cell",
  "footer",
  "row",
] as const;

export const aromaTable = defineSlotRecipe({
  className: "aroma-table",
  jsx: [
    "Table",
    "TableSide",
    "TableRowCells",
    "TableHeaderSortable",
    "SortButton",
    "TableNoResult",
  ],
  slots,
  base: {
    wrapper: {
      overflow: "hidden",
    },
    container: tableBorderStyles,
    root: {
      width: "100%",
    },
    head: {
      bg: "background.decorative.neutral.base-subtle",
    },
    header: {
      ...cellStyles,
      textStyle: "title.2xs",
      color: "content.neutral.base.subtle",
      textAlign: "left",

      "&[data-justify-right]": {
        textAlign: "right",
        "& > div": {
          display: "flex",
          justifyContent: "flex-end",
        },
      },
    },
    headerContent: {
      gap: "gap.1",
      alignItems: "center",
    },
    row: {
      borderBottomWidth: "m",
      borderStyle: "solid",
      borderColor: "border.neutral.subtle",
      _last: {
        borderBottom: "none",
      },
      _hover: {
        "&:not(thead > tr)": {
          bg: "background.neutral.base.subtlest-hover",
        },
      },
    },
    cell: {
      ...cellStyles,
      textStyle: "paragraph.m.regular",
      color: "content.neutral.base.bold",

      "&[data-justify-right]": {
        textAlign: "right",
      },
    },
  },
  variants: {
    lines: {
      1: {
        cell: {
          height: cellStyles.height,
        },
      },
      2: {
        cell: {
          height: "calc(2 * {sizes.m})",
        },
      },
    },
    side: {
      left: {
        container: {
          borderRightRadius: 0,
          borderRight: 0,
          shadow: "effect.shadow.bolder-right",
          zIndex: 1,
          width: "initial",
        },
      },
      right: {
        container: {
          borderLeftRadius: 0,
          borderLeft: 0,
          shadow: "effect.shadow.bolder-left",
          zIndex: 1,
          width: "initial",
        },
      },
      center: {
        container: {
          overflowX: "auto",
          scrollbarWidth: "thin",
          flex: 1,
          '&[data-state="left"]': {
            borderLeftRadius: 0,
            borderLeft: 0,
          },
          '&[data-state="right"]': {
            borderRightRadius: 0,
            borderRight: 0,
          },
          '&[data-state="both"]': {
            borderRadius: 0,
            borderLeft: 0,
            borderRight: 0,
          },
        },
      },
    },
    withBorder: {
      true: {
        container: {
          borderRadius: "l",
        },
      },
      false: {
        container: {
          borderRadius: "2xl",
          border: "none",
          '&[data-part="left"]': {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          },
          '&[data-part="right"]': {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          },
        },
      },
    },
  },
  defaultVariants: { lines: 1, withBorder: true },
});
